<template>
  <div class="grid pt-6">
    <div class="inline-grid flow-root bg-gray-50 rounded-lg px-6 pb-8">
      <div class="-mt-6">
        <div>
          <span class="inline-flex w-12 h-12 items-center justify-center p-3 bg-green-400 rounded-3xl shadow-lg">
              <i :class="[icon, 'text-2xl text-white']"></i>
          </span>
        </div>
        <h3 class="mt-8 text-lg font-medium text-gray-900 tracking-tight">{{ title }}</h3>
        <p class="mt-5 text-base text-gray-500">
          {{ description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  icon: {
    type: String,
  },
  title: {
    type: String,
  },
  description: {
    type: String,
  }
});
</script>
